if (typeof MainHeader !== "function") {
  class MainHeader extends HTMLElement {
    constructor() {
      super();
      this.mount();
    }

    mount() {
      /* -- > DRAWERS < -- */

      document.querySelectorAll("#main > div").forEach((elm) => {
        if (!elm.classList.contains("no-inert")) {
          elm.setAttribute("data-js-inert", "");
        }
      });
      window.inertElems = document.querySelectorAll("[data-js-inert]");

      // Sticky header

      if (this.hasAttribute("data-sticky-header")) {
        const stickyHeader = document.createElement("div");
        stickyHeader.classList = "sticky-header site-header";
        stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
					${this.querySelector(".header__bottom").innerHTML}
					<div style="display:flex;gap:15px;">
						${this.querySelector(".area--search").outerHTML}
						${this.querySelector(".area--cart").outerHTML}
					</div>
				</div>
				<div class="site-header element--hide-on-portable-plus">
					${this.querySelector(".header-container--top").innerHTML}
				</div>`;
        document.body.append(stickyHeader);
        stickyHeader.querySelectorAll("[id]").forEach((elm) => {
          elm.id = `${elm.id}-sticky`;
        });
        stickyHeader
          .querySelectorAll(".site-nav [aria-controls]")
          .forEach((elm) => {
            elm.setAttribute(
              "aria-controls",
              `${elm.getAttribute("aria-controls")}-sticky`
            );
          });

        window.lst = window.scrollY;
        window.lhp = 0;

        const stickyHeaderDeskBound = this.querySelector(".header__bottom");
        const stickyHeaderMobileBound = this.querySelector(".header__top");

        this.SCROLL_StickyHelper = () => {
  const st = window.scrollY;

  const bound = window.innerWidth >= 1024
    ? stickyHeaderDeskBound
    : stickyHeaderMobileBound;

  // Agar original header screen me visible hai → sticky hide
  if (bound.getBoundingClientRect().top >= 0) {
    stickyHeader.classList.remove("show");
    return;
  }

  // Thoda sa bhi scroll ho jaaye → sticky show
  if (st > 10 && !stickyHeader.classList.contains("show")) {
    stickyHeader.classList.add("show");
  }
};


        window.addEventListener("scroll", this.SCROLL_StickyHelper, {
          passive: true,
        });
      }

      // drawer connections

      document.querySelectorAll("[data-js-sidebar-handle]").forEach((elm) => {
        if (elm.hasAttribute("aria-controls")) {
          const elmSidebar = document.getElementById(
            elm.getAttribute("aria-controls")
          );

          elm.addEventListener("click", (e) => {
            e.preventDefault();

            const isOpen = elmSidebar.classList.contains("sidebar--opened");

            if (isOpen) {
              elm.setAttribute("aria-expanded", "false");
              elmSidebar.hide();
            } else {
              elm.setAttribute("aria-expanded", "true");
              elmSidebar.show();
            }
          });

          elm.addEventListener("keyup", (e) => {
            if (e.keyCode === window.KEYCODES.RETURN) {
              const isOpen = elmSidebar.classList.contains("sidebar--opened");

              if (isOpen) {
                elm.setAttribute("aria-expanded", "false");
                elmSidebar.hide();
              } else {
                elm.setAttribute("aria-expanded", "true");
                elmSidebar.show();
                elmSidebar.querySelector("[data-js-close]")?.focus();
              }
            }
          });
        }
      });

      // closing drawers

      document
        .querySelectorAll("sidebar-drawer [data-js-close]")
        .forEach((elm) => {
          elm.addEventListener("click", (e) => {
            e.preventDefault();
            if (
              e.target.closest(".sidebar").classList.contains("sidebar--opened")
            ) {
              e.target.closest(".sidebar").hide();
            }
          });
        });
      document.querySelector(".site-overlay").addEventListener("click", () => {
        if (document.querySelector(".sidebar--opened")) {
          document.querySelector(".sidebar--opened").hide();
        }
      });
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == window.KEYCODES.ESC) {
          if (document.querySelector(".sidebar--opened")) {
            document.querySelector(".sidebar--opened").hide();
          }
        }
      });

      // resizing drawers

      const rootHeight = document.getElementById("root-height");
      this.RESIZE_SidebarHelper = debounce(() => {
        rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
					--window-width: ${document.body.clientWidth}px;
				}`;
      }, 200);
      window.addEventListener("resize", this.RESIZE_SidebarHelper);
      rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
			}`;
      document.body.classList.add("header-loaded");

      // submenu masonry

      document
        .querySelectorAll(".site-nav.style--classic .submenu-masonry")
        .forEach((elm) => {
          if (Macy) {
            const submenuMacy = new Macy({
              container: elm,
              columns: parseInt(elm.getAttribute("data-columns")),
              margin: 30,
            });
            setTimeout(() => {
              submenuMacy.reInit();
            }, 100);
          }
        });

      // predictive search

      if (
        JSON.parse(document.getElementById("shopify-features").text)
          .predictiveSearch &&
        KROWN.settings.predictive_search_enabled == "true"
      ) {
        // predictive search (sidebar)

        document
          .querySelectorAll("[data-js-open-search-drawer")
          .forEach((elm) => {
            elm.addEventListener("click", (e) => {
              e.preventDefault();
              if (
                !document.body.classList.contains("predictive-script-loaded")
              ) {
                document.body.classList.add("predictive-script-loaded");
                const predictiveSearchJS = document.createElement("script");
                predictiveSearchJS.src =
                  KROWN.settings.predictive_search_script;
                document.head.appendChild(predictiveSearchJS);
              }
              setTimeout(() => {
                document.querySelector("#search-form-sidebar").focus();
              }, 10);
            });
          });
      } else {
        this.querySelector("search-form").addEventListener("click", (e) => {
          e.preventDefault();
          window.location.href = KROWN.settings.routes.search_url;
        });
      }

      document
        .querySelectorAll(
          ".style--classic .has-submenu, .style--classic .has-babymenu"
        )
        .forEach((elm) => {
          if (!elm.classList.contains("mega-link")) {
            elm.addEventListener("touchstart", (e) => {
              elm.firstElementChild.style.pointerEvents = "none";
              elm.classList.toggle("focus");
            });
          }
        });

      // tab navigation for the menu

      document
        .querySelectorAll(".site-nav.style--classic .has-submenu > a")
        .forEach((childEl) => {
          const elm = childEl.parentNode;

          elm.addEventListener("keydown", (e) => {
            if (e.keyCode == window.KEYCODES.RETURN) {
              if (!e.target.classList.contains("no-focus-link")) {
                e.preventDefault();
              }
              if (!elm.classList.contains("focus")) {
                elm.classList.add("focus");
                elm.setAttribute("aria-expanded", "true");
              } else if (
                document.activeElement.parentNode.classList.contains(
                  "has-submenu"
                ) &&
                elm.classList.contains("focus")
              ) {
                elm.classList.remove("focus");
                elm.setAttribute("aria-expanded", "true");
              }
            }
          });

          if (elm.querySelector(".submenu-holder > li:last-child a")) {
            elm
              .querySelector(".submenu-holder > li:last-child a")
              .addEventListener("focusout", (e) => {
                if (elm.classList.contains("focus")) {
                  elm.classList.remove("focus");
                  elm.setAttribute("aria-expanded", "false");
                }
              });
          }
        });

      document
        .querySelectorAll(
          ".site-nav.style--classic .has-babymenu:not(.mega-link) > a"
        )
        .forEach((childEl) => {
          const elm = childEl.parentNode;

          elm.addEventListener("keydown", (e) => {
            if (e.keyCode == window.KEYCODES.RETURN) {
              if (!e.target.classList.contains("no-focus-link")) {
                e.preventDefault();
              }
              if (!elm.classList.contains("focus")) {
                elm.classList.add("focus");
                elm.setAttribute("aria-expanded", "true");
              } else {
                elm.classList.remove("focus");
                elm.setAttribute("aria-expanded", "false");
              }
            }
          });

          if (elm.querySelector(".babymenu li:last-child a")) {
            elm
              .querySelector(".babymenu li:last-child a")
              .addEventListener("focusout", (e) => {
                if (elm.parentNode.classList.contains("focus")) {
                  elm.parentNode.classList.remove("focus");
                  elm.parentNode.setAttribute("aria-expanded", "false");
                }
              });
          }
        });
    }

    unmount() {
      window.removeEventListener("resize", this.RESIZE_SidebarHelper);
    }
  }

  if (typeof customElements.get("main-header") == "undefined") {
    customElements.define("main-header", MainHeader);
  }
}

if (typeof SidebarDrawer !== "function") {
  class SidebarDrawer extends HTMLElement {
    constructor() {
      super();
      this.querySelector("[data-js-close]").addEventListener("click", () => {
        this.hide();
      });
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" || e.keyCode === 27) {
          const openedSidebar = document.querySelector(
            "sidebar-drawer.sidebar--opened"
          );
          if (openedSidebar) {
            openedSidebar.hide();
          }
        }
      });
    }

    /*
     * generic hide/show functions
     */

    show() {
      this._opened = true;
      document.body.classList.add("sidebar-opened");
      if (this.classList.contains("sidebar--right")) {
        document.body.classList.add("sidebar-opened--right");
      } else if (this.classList.contains("sidebar--left")) {
        document.body.classList.add("sidebar-opened--left");
      }
      if (
        this.id == "site-cart-sidebar" &&
        document.getElementById("cart-recommendations-sidebar")
      ) {
        setTimeout(() => {
          document
            .querySelector("#cart-recommendations-sidebar css-slider")
            ?.resetSlider();
        }, 10);
      }
      this.style.display = "grid";
      setTimeout(() => {
        this.classList.add("sidebar--opened");
        // window.inertElems.forEach(elm=>{
        // 	elm.setAttribute('inert', '');
        // })
      }, 15);
    }

    hide() {
      this._opened = false;
      this.classList.remove("sidebar--opened");

      document.body.classList.remove("sidebar-opened");
      document.body.classList.remove("sidebar-opened--left");
      document.body.classList.remove("sidebar-opened--right");
      // window.inertElems.forEach(elm=>{
      // 	elm.removeAttribute('inert');
      // })

      document
        .querySelector(`[aria-controls="${this.id}"]`)
        ?.setAttribute("aria-expanded", "false");

      setTimeout(() => {
        this.style.display = "none";
      }, 501);
    }
  }

  if (typeof customElements.get("sidebar-drawer") == "undefined") {
    customElements.define("sidebar-drawer", SidebarDrawer);
  }
}

if (typeof MobileNavigation !== "function") {
  class MobileNavigation extends HTMLElement {
    constructor() {
      super();

      this._openedFirstSubmenu = false;
      this._openedSecondSubmenu = false;

      // --- Open first .has-submenu item by default ---
      const firstMenuItem = this.querySelector(".has-submenu");
      if (firstMenuItem) {
        firstMenuItem.classList.add("opened");
        this._openedFirstSubmenu = true;
        this.classList.add("opened-first-submenu");
        this._resizeContainer(); // Resize based on default open
      }

      this.querySelectorAll(".has-submenu > a").forEach((elm) => {
        elm.addEventListener("click", (e) => {
          e.preventDefault();
          // Close all other opened submenus
          this.querySelectorAll(".has-submenu.opened").forEach((openItem) => {
            openItem.classList.remove("opened");
          });

          // Mark this submenu as opened
          e.target.closest("li").classList.add("opened");

          if (!this._openedFirstSubmenu) {
            this._openedFirstSubmenu = true;
            this.classList.add("opened-first-submenu");
          }
          // e.target.closest('li').classList.add('opened');
          this._resizeContainer();
        });
      });

      this.querySelectorAll(".has-babymenu > a").forEach((elm) => {
        elm.addEventListener("click", (e) => {
          e.preventDefault();
          // Close all other babymenus
          this.querySelectorAll(".has-babymenu.opened").forEach((openItem) => {
            openItem.classList.remove("opened");
          });

          // Open current
          e.target.closest("li").classList.add("opened");

          if (!this._openedSecondSubmenu) {
            this._openedSecondSubmenu = true;
            this.classList.add("opened-second-submenu");
          }
          // e.target.closest('li').classList.add('opened');
          this._resizeContainer();
        });
      });

      this.querySelectorAll(".submenu-back a").forEach((elm) => {
        elm.addEventListener("click", (e) => {
          e.preventDefault();
          if (this._openedSecondSubmenu) {
            this._openedSecondSubmenu = false;
            this.classList.remove("opened-second-submenu");
            this._resizeContainer();
          } else if (this._openedFirstSubmenu) {
            this._openedFirstSubmenu = false;
            this.classList.remove("opened-first-submenu");
            this._resizeContainer(true);
          }
          setTimeout(() => {
            e.target.closest("li.opened").classList.remove("opened");
          }, 301);
          // e.preventDefault();
        });
      });
    }

    _resizeContainer(main = false) {
      if (main) {
        this.style.height = `auto`;
      } else {
        if (this._openedSecondSubmenu) {
          this.style.height = `${
            this.querySelector(".opened .babymenu").scrollHeight
          }px`;
        } else if (this._openedFirstSubmenu) {
          this.style.height = `${
            this.querySelector(".opened .submenu").scrollHeight
          }px`;
        }
      }
    }
  }

  if (typeof customElements.get("mobile-navigation") == "undefined") {
    customElements.define("mobile-navigation", MobileNavigation);
  }
}

// document.addEventListener("DOMContentLoaded", (event) => {
//   var mobile_sort = document.getElementById('mobile-SortBy');
// var vikash_sort = document.getElementById('vikash-sort');
// var div = document.createElement("div");
// var divappended = vikash_sort.appendChild(div);
//   divappended.appendChild(mobile_sort);
// });
// document.getElementsByClassName("button--outline button--fullwidth").firstChild.innerHTML= 'Filter';
